import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, ArrowRight } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-12 md:py-20 px-4 md:px-6 relative overflow-hidden bg-[var(--bg-surface)]" data-id="element-283">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[var(--accent)] opacity-[0.03] blur-[100px] rounded-full pointer-events-none" data-id="element-284" />

      <div className="max-w-[720px] mx-auto relative z-10" data-id="element-285">
        <div className="text-center mb-8 md:mb-12" data-id="element-286">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[var(--accent-soft)] text-[var(--accent)] mb-4" data-id="element-287">
            <Lightbulb className="w-6 h-6" data-id="element-288" />
          </div>
          <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] mb-4 leading-tight" data-id="element-289">
            What if I told you the problem isn't the food?
          </h2>
          <p className="text-xl md:text-2xl text-[var(--accent)] font-serif italic" data-id="element-290">
            And it’s definitely not your parenting.
          </p>
        </div>

        <div className="bg-[var(--bg-card)] p-6 md:p-10 rounded-2xl border border-[var(--accent)]/20 shadow-md relative overflow-hidden mb-8" data-id="element-291">
          <div className="absolute top-0 left-0 w-1.5 h-full bg-[var(--accent)]" data-id="element-292"></div>

          <h3 className="text-xl md:text-2xl font-bold text-[var(--text-heading)] mb-4" data-id="element-293">
            The problem is the{' '}
            <span className="text-[var(--accent)]" data-id="element-294">Texture Gap.</span>
          </h3>

          <p className="text-base md:text-lg text-[var(--text-primary)] leading-relaxed mb-6" data-id="element-295">
            Most programs try to force a child to change their behavior.{' '}
            <strong data-id="element-296">We do the opposite. We change the sensory input.</strong>
          </p>

          <div className="bg-[var(--bg-elevated)] rounded-xl p-5 md:p-6 border border-[var(--border-subtle)]" data-id="element-297">
            <p className="text-sm md:text-base text-[var(--text-primary)] leading-relaxed" data-id="element-298">
              By using the <strong data-id="element-299">"Texture Hacking" Method</strong>, we bridge
              the gap between their "Safe Foods" and "New Foods" using culinary
              science and sensory desensitization.
            </p>

            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-3 text-sm font-medium text-[var(--text-heading)]" data-id="element-300">
              <span className="bg-[var(--bg-card)] px-4 py-2 rounded-lg shadow-sm border border-[var(--border-subtle)]" data-id="element-301">
                Safe Foods
              </span>
              <ArrowRight className="w-5 h-5 text-[var(--accent)] rotate-90 sm:rotate-0" data-id="element-302" />
              <span className="bg-[var(--accent-soft)] text-[var(--accent)] px-4 py-2 rounded-lg border border-[var(--accent)]/20" data-id="element-303">
                Texture Hacking
              </span>
              <ArrowRight className="w-5 h-5 text-[var(--accent)] rotate-90 sm:rotate-0" data-id="element-304" />
              <span className="bg-[var(--bg-card)] px-4 py-2 rounded-lg shadow-sm border border-[var(--border-subtle)]" data-id="element-305">
                New Foods
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}